import type { ReactNode } from 'react';
import { Typography } from 'antd';

const { Text } = Typography;

interface Props {
  icon: ReactNode;
  iconColor: string;
  title: string;
  subtitle?: string;
}

/**
 * Schedule section header — caption-style with icon disc.
 * Matches Analytics tab visual language.
 */
export default function SectionHeader({ icon, iconColor, title, subtitle }: Props) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        marginBottom: 10,
        paddingLeft: 2,
      }}
    >
      <div
        style={{
          width: 28,
          height: 28,
          borderRadius: 9,
          background: `linear-gradient(135deg, ${iconColor}14 0%, ${iconColor}26 100%)`,
          border: `1px solid ${iconColor}1a`,
          color: iconColor,
          fontSize: 13,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        {icon}
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <Text
          style={{
            fontSize: 14,
            fontWeight: 700,
            color: 'var(--bl-text-strong, #0f172a)',
            display: 'block',
            letterSpacing: -0.1,
          }}
        >
          {title}
        </Text>
        {subtitle && (
          <Text
            style={{
              fontSize: 11,
              color: 'var(--bl-text-muted, #9ca3af)',
              display: 'block',
            }}
          >
            {subtitle}
          </Text>
        )}
      </div>
    </div>
  );
}
